import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, CardContent } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { adminLogin } from "../../lib/adminAuth";

const AdminLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [form, setForm] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const redirectTo = location.state?.from?.pathname || "/admin/dashboard";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return; // avoid double-click submits

    setLoading(true);
    setError("");

    try {
      const email = form.email.trim(); // avoid leading/trailing spaces
      const password = form.password;

      await adminLogin(email, password);

      // optional debug
      console.log("Login success, redirecting to:", redirectTo);

      navigate(redirectTo, { replace: true });
    } catch (err) {
      setError(err?.message || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-stone-50 flex items-center justify-center px-6">
      <Card className="w-full max-w-md rounded-2xl shadow-sm border border-stone-200">
        <CardContent className="p-8">
          <h1 className="text-2xl font-bold text-stone-900 mb-2">Admin Login</h1>
          <p className="text-stone-600 mb-6">Sign in to access your dashboard</p>

          {error && (
            <div className="mb-4 rounded-lg bg-red-50 text-red-700 px-3 py-2 text-sm">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm text-stone-700 mb-1">Email</label>
              <input
                type="text"
                name="email"
                value={form.email}
                onChange={handleChange}
                className="w-full rounded-xl border border-stone-300 px-3 py-2 outline-none focus:ring-2 focus:ring-amber-500"
                placeholder="info@glgif.org"
                autoComplete="username"
                required
              />
            </div>

            <div>
              <label className="block text-sm text-stone-700 mb-1">Password</label>
              <input
                type="password"
                name="password"
                value={form.password}
                onChange={handleChange}
                className="w-full rounded-xl border border-stone-300 px-3 py-2 outline-none focus:ring-2 focus:ring-amber-500"
                placeholder="Enter admin password"
                autoComplete="current-password"
                required
              />
            </div>

            <Button
              type="submit"
              className="w-full bg-amber-700 hover:bg-amber-800 text-white rounded-xl"
              disabled={loading}
            >
              {loading ? "Signing in..." : "Sign In"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;
